import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPhone: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="phone, iphone, mobile"><path fillRule="evenodd" clipRule="evenodd" d="M5 4.75C5 2.67893 6.67893 1 8.75 1H15.25C17.3211 1 19 2.67893 19 4.75V19.25C19 21.3211 17.3211 23 15.25 23H8.75C6.67893 23 5 21.3211 5 19.25V4.75ZM9.75 18.5C9.33579 18.5 9 18.8358 9 19.25C9 19.6642 9.33579 20 9.75 20H14.25C14.6642 20 15 19.6642 15 19.25C15 18.8358 14.6642 18.5 14.25 18.5H9.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconPhone;
